import * as React from "react";
import { Themes, ThemeVariants } from "@vwpfs/mary-air-lib/theme/_Types";
import "../../../assets/stylesheets/libs/core/03-base/loader.scss";
import { Logo } from "@vwpfs/mary-air-lib/components/air/03-base/Logo";

interface Props {
    force?: boolean;
}

/**
 *
 * @param props
 */
export const PreLoader: React.FunctionComponent<Props> = (props) => (
    <div className={`scl-preloader__wrapper ${props.force ? "scl-preloader__wrapper-forcedshow" : ""}`}>
        <div className="scl-preloader">
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
            <Logo theme={Themes.CLAUDE} variant={ThemeVariants.CONTRAST}/>
        </div>
    </div>
);

